import React from 'react';

// iOS sheet-style modal: dimmed blurred scrim + thick material panel.
// Pass hideDefaultClose when the content provides its own Cancel/Done
// buttons, to avoid a redundant trailing "Close".
const Modal = ({ open, onClose, children, className = '', hideDefaultClose = false }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className={`glass-sheet p-8 w-full max-w-md max-h-[88vh] overflow-y-auto animate-scale-in ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
        {onClose && !hideDefaultClose && (
          <button
            onClick={onClose}
            className="btn btn-secondary mt-6 w-full"
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;
